export class DataEditSummaryResponse {
  title: string;
  id: string;
  summariesByType: Array<DataEditSummariesByTypeResponseModel>;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    } else {
      this.summariesByType = new Array<DataEditSummariesByTypeResponseModel>();
    }
  }
}

export class DataEditSummariesByTypeResponseModel{
  categoryType: string;
  dataTransportSummaries: Array<DataTransportSummaryResponse>;
  categoryTitle: string;
  categoryIconClass: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    } else {
      this.dataTransportSummaries = new Array<DataTransportSummaryResponse>();
    }
  }
}

export class DataTransportSummary {
  title: string;
  numberOfFieldsEdited: number;
  numberOfRecordsEdited: number;
  transportId: string;
  transportApi: string;
  sourceType: any;
  destinationType: any;
  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    } else {
      this.numberOfFieldsEdited = 0;
      this.numberOfRecordsEdited = 0;
    }
  }
}

export class DataTransportSummaryResponse extends DataTransportSummary {
  dataEditFieldSummaryResponses: Array<DataEditFieldSummaryResponse> = new Array<DataEditFieldSummaryResponse>();
}

export class DataEditFieldSummaryResponse {
  title: string;
  numberOfRecordsEdited: number;
  reference: string;
  sourceField: string;
  // processed
  toolTip: string;
}


export class FieldDetail {
  title: string;
  value: string;
  valueType: ValueType;
}

export class FieldEditHistory {
  currentValue: any;
  previousValue: any;
  value: string;
  modifiedDate: Date;
  dataTransportSummary: DataTransportSummary;
  historyDetails: Array<HistoryDetail> = [];
  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export enum ValueType {
  Text,
  Url,
  DateTime
}

export class HistoryDetail {
  title: string;
  value: any;
  valueType: ValueType;
  order: number;
  icon: string;
  // processed
  styleClass: string;
  isUrl: boolean;
}

export class DataEditHistoryResponse {
  title: string;
  transportSummary: DataTransportSummary;
  fieldDetails: Array<FieldDetail> = [];
  editHistories: Array<FieldEditHistory> = [];
  conversationId: string;
  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export interface DataTracingFieldHistoryAiTimelineEntry {
  order: number;
  date: string | null;
  action: string;
  actor: string | null;
  sourceSystem: string;
  valueAfter: string;
  valueBefore: string | null;
}

export interface DataTracingFieldHistoryAiResponse {
  currentValue: string;
  totalEdits: number;
  timeline: DataTracingFieldHistoryAiTimelineEntry[];
  insights: string[];
}
